module.exports = __webpack_public_path__ + "img/blueMoon-min.435ff728.png";